import jpLocale from "element-ui/lib/locale/lang/ja"; //element
import jaJP from 'vxe-table/lib/locale/lang/ja-JP' // 日语
const jp = {
  message: {
    button: {
      generateItemNumber: "物品コードを生成する",
      upgradeRevchangeMfrGenNumber:
        "バージョンアップ/生成された供給先のコードを変更する",
      generateCodeNumber: "番号を生成する",
      upgradeSequence: "シリアル番号をアップグレードする",
      upgradeRev: "バージョンアップ",
      changeManufacture: "製造元を変更する",
      save: "保存",
      delete: "削除",
      deleteForm: "当該シートを削除する",
      Undo: "元に戻す",
      cancel: "キャンセル",
      clearSelected: "セレクトをキャンセルする",
      replace: "置き替え",
      clear: "クリア",
      add: "追加",
      edit: "編集",
      affirm: "確認",
      import: "インポート",
      download: "ダウンロード",
      preview: "プレビュー",
      export: "エクスポート",
      exportAll: "全部エクスポート",
      importRemak: "計画備考インポート",
      creat: "新規作成",
      actions: "操作",
      comment: "備考",
      details: "詳細",
      reset: "リセット",
      create: "新規作成",
      createNow: "立即新規作成",
      search: "検索",
      simpleSearch: "簡易検索",
      advancedSearch: "上級検索",
      bookmark: "コレクション",
      cancelBookmark: "コレクションをキャンセルする",
      pause: "一時停止",
      cancelPause: "キャンセル一時停止",
      cancel: "キャンセル",
      createChange: "新規作成変更",
      createItemQuality: "品質シートの作成",
      release: "更新",
      submit: "提出",
      next: "次へ",
      exportModel: "エクスポートテンプレート",
      done: "完成",
      toImport: "アップロード",
      check: "チェック",
      order: "配列する",
      authorize: "授権",
      confirmSetting: "セッティングの確認",
      saveAs: "名前を付けて保存する",
      return: "リターン",
      calculateScore: "得点を計算する",
      effect: "発効",
      invalid: "反発効",
      projectStatus: "プロジェックトの状態",
      cancelCode: "キャンセルコード",
      BOMshow: "第一層のBOMしか表示しない",
      ProductDataQuery: "製品データシート",
      taskstatement: "タスクの検索シート",
      executorstatement: "執行の進捗シート",
      remark: "計画の備考シート",
      testLink: "テスト接続",
      downloadAttachment: "デリバリーダウンロード",
      list: "リスト",
      state: "状態",
      type: "タイプ",
      members: "メンバー",
      copyBOM: "BOMを複製する",
      stcokQuery: "在庫を検索する",
      gantt: "ガント図",
      TreeView: "ツリー図の表示",
      createCAPA: "新規作成CAPA",
      previousPage: "前のページ",
      nextPage: "次のページ",
      fill: "じゅうてん",
      expandAll: 'ワンクリック展開',
      payload: 'さぎょうふかど',
      startDate: "開始の時間",
      endDate: "終了時間",
      selectUser: "ユーザーの検索",
      selectRange: "検索範囲",

      assignRoles: "キャラクターの配布",
      removenRoles: "やくわりのさくじょ",
      authorize: "権限の付与",
      authShift: "権限の移譲",

      print: '印刷いんさつ',
      copy: 'レプリケーション',
      paste: '貼り付け',
      upFill: 'アップフィル',
      downFill: 'アンダーフィル',
      expend: "展開する",
      close: "閉じる（とじる）",

      RegenerateXML: "XMLファイルを再生成する",
      exportExcel: 'Excel エクスポート',
      restoreChange: '変更状態回退',

      closeProject: '閉じる',
    },
    title: {

      globalSearch: '全体検索',
      personalSearch: '個人検索',
      noPendingItem: "変更されていない物品を濾過する",
      readAndAgree: "私は内容をしかっり読んだ上、同意する",
      addApprover: "審査者",
      addObserver: "観察者",
      annotation: "コメント",
      userLogin: "ユーザーログイン",
      login: "ログイン",

      BatchImportDoc: ' 図面/ドキュメントの一括インポート',

      OverallStatus: "全体テータス",
      ScheduleStatus: "計画ステータス",
      CostStatus: "原価ステータス",
      ResourceStatus: "リソースステータス",

      emptyText: "一時的にデータ無し",
      emptyTextInAttachment: 'ファイル/フォルダをテーブルの場所にドラッグ＆ドロップしてアップロードするか、追加ボタンをクリックしてアップロードしてください ',

      allFilter: "全部",
      initial: "初期化",

      welcome: "システムへようこそ",
      releaseFlow: "発表流れの一覧",
      workflow: "ワークフロー",
      addForStatus: "状態を追加する",
      editAP_OB: "編集の審査者",
      addAP_OB: "審査者と観察者を追加する",
      searchUser: "ユーザーを検索する",
      addStatus: "状態を追加する",
      approver: "審査者",
      observer: "観察者",
      comments: "コメント",
      workflowExport: "ワークフローエクスポート.xlsx",
      BOMdoc: "BOMエクスポート.xlsx",
      importRelationshipTemplate: "関連オブジェクトインポートテンプレート.xlsx",
      importMfrpTemplate: "製造業者インポートテンプレート.xlsx",

      manualNextStatus: "次の状態",

      check: "審査",
      approveRelease: "承認発表",
      approve: "承認",
      rejectRelease: "リリースを拒否する",
      reject: "拒否",
      finish: "完成",
      fileName: "ファイル名",
      importDate: "アップロードの時間",

      aboutUs: "弊社について",
      studyOnline: "オンラインで勉強する",
      serviceOnline: "オンラインサービス",
      changePW: "暗証番号の見直し",
      logout: "ログアウト",
      userSetting: "プライベート設定",
      viewTool: "3Dツール",

      search: "検索",
      quickSearch: "クリック検索",
      advancedSearch: "上級検索",
      searchCriteria: "条件を検索する",
      searchResult: "検索の結果",
      totalResults: "合計を検索した:",
      resultsNums: " ",
      missingRows: "権限のない結果を表示しない.",
      searchUnit: "つの結果",

      importFile: "オブジェクトをインポートする",
      importBOM: "BOMをインポートする",
      importRelationship: "関連オブジェクトのインポート​",
      importMfrp: "メーカー部品のインポート",
      fileModel: "ファイルテンプレート",
      fileImport: "ファイルアップロード",
      isGenerateCodeNumber: "番号を生成するか",
      isPreemptive: "プリエンプトモード",
      importgeneralBOM: "汎用BOMをインポートする",
      ImportPlanRemarks: "プロジェクト計画備考インポート",
      projectSchedule: "プロジェクト進捗プレビュー",
      projectSchedule: "プロジェクト進捗",

      // myProject:'プロジェクト看板',
      myProcess: "マイ流れ",
      myDashboard: "ダッシュボード",
      myProject: "プロジェクト看板",
      myAgent: "タスク看板",

      componentLibrary: "部品のライブラリー",

      myPriority: "マイ処理待ち",
      myTracing: "マイトラッキング",
      mySubmit: "マイ提出",
      myNotice: "マイ通知",
      changeNotice: "通知を変更する",
      setting: "プライベート設定",
      priorityChange: "処理待ちの変更",
      participationChange: "参与した変更",
      submittedChange: "変更を提出済み",
      cover: "表紙",
      affectedModel: "影響された物品",
      workflow: "ワークフロー",
      summary: "一覧 (BOM発効の流れ)",
      history: "履歴",

      approve: "承認と公表",
      reject: "リリースを拒否する",
      add: "追加",

      currentVolume: "今現在のデータ量",
      dilation: "容量拡大",

      rev: "バージョン",
      createFolder: "请创建对应文件夹",
      saveNode: '保存节点',

      create: "新規作成",
      changeObject: "影響された物品",
      createModel: "物品の新規作成",
      createChange: "新規作成の変更",
      createManufacturer: "製造元を新規作成する",
      createManufacturerPart: "製造元部品の新規作成",
      quickCreate: "クリック新規作成",

      createList: "リストの新規作成",
      baseInfo: "基本情報",
      listVal: "リスト値",
      listWhereUsed: "使用する位置",
      createWorkflow: "ワークフローの新規作成",

      autoNumber: "番号を自動的に生成する",
      autoNumber2: "自動的に番号を付ける",
      userGroup: "ユーザーグループ",

      pageOne: "第一ページ目",
      pageTwo: "第二ページ目",
      pageThree: "第三ページ目",

      relationship: "オブジェクトを関連する",
      manufacturer: "製造元",
      attachment: "アタッチメント",
      itemAttachment: "物件の添付ファイル",
      titleBlock: "詳細情報",

      list: "リスト",
      preferences: "プレファレンス",
      whereUsed: "使用する位置",
      PGWhereUsed: "変更待ちの位置",
      pendingChange: "変更待ち",
      releasedChange: "変更のリリース",
      deliverables: "デリバリー",

      addRole: "キャラクターを追加する",
      editRole: "キャラクターを編集する",
      saveAs: "名前を付けて保存する",
      editPrivilege: "権限の編集",
      addPrivilege: "権限を追加する",
      changeStatusTo: "状態を に変更する",
      emailSetting: "メールアドレスのセッティング",
      IntegrationSetting: "統合設定",
      preference: "プレファレンスのセッティング",
      emailHost: "メールアドレスのサーバー",
      emailPost: "ポートの番号",
      emailUser: "メールアドレスのアカウント",
      emailPassWord: "メールアドレスの暗証番号",
      selectTemplate: "テンプレートを選択する",
      resourceMapping: "リソースのマッピング",
      code: "コード",
      codeInstructions: "規則の名称",
      des: "ディスクリプション",
      codeObject: "コードのオブジェクトを選択する",
      defineCodePro: "コードのプロパティーを定義する",
      proNormalState: "正常な状態",
      prosuspended: "既に一時停止になった",
      proShutDown: "シャットダウン済み",
      tasknormal: "タスクが正常である",
      taskOverdue: "期限切れになる",
      taskDelay: "予測値を超えた",
      taskSuspended: "一時停止の段階",
      taskClose: "閉じっている段階",
      rootName: "所属プロジェクト",
      firstLayerProjectName: "所属レベルのタスク",
      parentName: "所属上級のタスク",
      proName: "プロジェクト名称",
      type: "タイプ",
      startTime: "	開始の時間",
      endTime: "終止時間",
      createTime: "新規作成の時間",
      overdueDays: "期限切れた日数",
      principal: "責任者",
      redLine: "赤線を引く",

      BOMCompare: "BOMシートと比較する",
      PurchaseList: "購買リスト",
      BOMGather: "BOM の纏め",

      priority: "処理待ち",
      inProcess: "進行中",
      completed: "完成済み",

      universal: "汎用",
      uploadLogo: "logoをアップロードする",
      uploadPictures: "クリックして写真をアップロードする",

      ConditionalSearch: "条件付けて、検索する",

      Checked: "選ばれた",
      className: "分類名",

      onlineNumbers: "オンラインの人数",
      allPerpon: "全ての人",

      showAttribute: "フィルドの表示",
      showAttributeName: "フィルド名を表示する",

      expend: "展開",
      close: "クローズ",

      Separator: "セパレータ",

      comperType: "比較のタイプ",
      warning_SameOne:
        "両方のBOM及びバージョンが比較で、完全に同様だと判断されたので、修正を行ってください",
      warning_Incomparable:
        "比較することより、両方が同様な項目が無いので、新たに選んでください",
      change_new: "修正（新）",
      change_old: "修正（旧）",
      addNew: "新規作成",
      searchName: "検索名",

      searchSave: "保存の検索",

      searchType: "検索タイプ",
      AppId: "アプリケーション番号",
      CorpId: "エンタープライズ番号",
      CorpSecret: "キー",

      authorize: "授権",
      folder: "フォルダ＃フォルダ＃",

      createFolder: "対応するフォルダを作成してください",
      saveNode: '保存ポイント',
      inheritBOM: 'BOMを継承しますか',

      allFields: 'すべて',
      startDate: "開始の時間",
      endDate: "終了時間",
      replacedResources: "置換されたリソース",
      replaced: '置換後',
      WeCom: 'WeCom（ウィーコム）',
      Dingding: 'DingTalk（ディングトーク）'
    },
    placeholder: {
      companyName: "会社名",
      userName: "ユーザー名",
      PW: "暗証番号",
      search: "入力してください",
      input: "入力してください",
      select: "選んでください",
      pickDate: "デートを選んでください",
      startDate: "開始の時間",
      endDate: "終了時間",
      selectAttribute: "プロパティーを選んでください",
      selectOperator: "演算子を選んでください",
      project: "プロジェクト",
      state: "状態",
      stateType: "状態のタイプ",
      lateType: "期限切れたタイプ",
      keyword: "キーワード",
    },
    success: {
      upLoad: "アップロードが成功した",
      downLoad: "ダウンロードが成功した",
      save: "保存が成功した",
      changePW: "暗証番号の修正が成功した",
      delete: "削除が成功した",
      addFavoriteSuccessfully: "コレクションの追加が成功した",
      removeFavoriteSuccessfully: "コレクションのキャンセルが成功した",
      actions: "操作が成功した",
    },
    error: {
      workflowNotNull: "ワークフローを空きにしてはいけない",
      commonServerError: "エラーが発生したので、管理者と連絡してください。",
      pickBaseClass: "タイプを選んでください。",
      cantModify: "既に使われたので、修正してはいけない。",
      cantDelete: "既に使われたので、削除してはいけない。",
      rejectNoComments: "拒否の理由を記入してください。",
      change: "修正が失敗した",
      notSame: "二回入力した内容が一致しない",
      nameRepeat: "名称を重複してはいけない",
      save: "保存が失敗した",
      name: "名称を空きにしてはいけない",
      performanceNum: "シートの番号を空きにしてはいけない",
      rejectToStatus: "リターンを拒否する状態を設置してください",
      invalidedrejectToStatus: "リターンを拒否する状態が次の状態にいない。",
      type: "タイプを空きにしてはいけない",
      input: "入力の内容が空であった",
      search: "検索が失敗した",
      pending: "決定待ちの状態を削除できない",
      noChange: "数値の変動がないので、保存が要らない。",
      pendding: "Pendding 状態は削除できない",
      addSame: "追加が失敗した: 重複したユーザーを追加できない",
      sameUser: "同じユーザーを重複に追加しないでください。",
      same: "製造元の部品を重複に追加しないでください。",
      add: "追加が失敗した",
      delete: "削除が失敗した",
      assginRoles: "キャラクターの配布が失敗した",
      privilegeAdd: "権限の追加が失敗した,",
      privilegeLoad: "権限のロードが失敗した,",
      privilegeUser: "追加が失敗した、当該ユーザーの権限が足りない",
      roleRefrash: "キャラクターの情報の更新が失敗した",
      roleAdd: "キャラクターの追加が失敗した",
      roleEdit: "キャラクターの編集が失敗した",
      noEdit: "編集禁止",
      deleteData: "選ばれたデータを削除できない、新たに選んでください",
      unDoData:
        "選ばれたデータが元に戻すことができないので、新たに選んでください",
      loadAP_OB: "ロードの審査者と観察者が失敗した",
      approve: "承認が失敗した",
      reject: "拒否が失敗した",
      param: "パラメータの書式が正しくない",
      emailHost: "メールアドレスのサーバーを空きにしてはいけない",
      emailAccounts: "メールアドレスを入力してください",
      emailAddress: "正しいメールアドレスを入力してください",
      emailPassWord: "暗証番号を空きにしてはいけない",
      post: "ポートの番号を空きにしてはいけない、数値にしなければならない",
      nameUsed: "当該名称が既に使われた",
      autoNumLength:
        "開始の数字の長さが数字の長さに下回らなければならないので、新たに編集してください",
      autoNumLengthLessTen: "数字の長さが9を超えてはいけない",
      disabledUser: "当該ユーザーが既に無効化になった",
      pleaseDisable: "有効化にするかを“いいえ”に変更してください",
      userMustOne:
        "流れが既に執行されたので、執行者を一人以上にしなければならない",
      onlyOneOrTwo: "比較のため、データを一つか二つしか選んではいけない",
      codeValueLength: "コードの長さを記入してください",

      selectOneExecutor: '置き換える実行者を選んでください',
      onlyOneExecutor: '実行者は1人だけ選べます'
    },
    tips: {
      alreadyLastPage: "最後のページに到達しました",
      alreadyFirstPage: "最上位のページに到達しました",
      intervalTooShort: "クエリのインターバルが短すぎます",
      notFind: "見つかりませんでした",
      searching: "検索中",
      upLoad:
        "ウィンドウズを閉じないでください！ファイルはアップロード中で、ご安心で待ってください",
      closeUpLoad: "バックグラウンドでアップロードするか？",
      downLoad:
        "ウィンドウズを閉じないでください！ファイルをダウンロード中で、安心で待ってください",
      noData: "一時的にデータ無し",
      terms:
        "「傑信クラウドプライバシーポリシー」と「傑信クラウドユーザー契約書」をしっかり読んで、同意してください, ",
      dataEnd: "データが既に最後になった!",
      dele_data: "削除する必要のあるデータを選んでください",
      companyName: "会社名を入力してください",
      userName: "ユーザー名を入力してください",
      PW: "暗証番号を入力してください",

      tip: "ヒント",
      name: "名称を入力してください",
      saveCancel: "保存が既にキャンセルした",
      deleteCancel: "削除が既にキャンセルした",
      cancel: "キャンセル済み",
      closeSucess: "クローズが成功した",
      tab: "画面にはTABの画面を少なくとも一つ存在しなければならない",
      exportModel:
        "“オブジェクトインポート”操作マニュアルをクリックして、チェックする",
      exportBom: "“BOMインポート”の操作マニュアルをクリックして、チェックする",

      noData: "一時的にデータ無し",
      quickCreateTips:
        "请先输入要创建 部件 的关键字，并点击新建,新建后填写必填属性。",
      createNewData: "当前类型下没有产品数据，请新建",

      Copyright:
        "著作権が所有する ©傑信ソフト科技(蘇州)有限公司 蘇ICP備16064918号-2",

      inputName: "名称を入力してください",
      inputDes: "ディスクリプションの情報を入力してください",

      changePW:
        "暗証番号の修正が成功した、確認をクリックして、新たにログインする",
      reLogin: "新たにログインしてください",

      workflow_101:
        "カキの問題が存在するので、全てのエラーを解決しない限り、状態が　　　　に変更できない ",
      workflow_102: "アラームしか存在しなければ、継続することができる",
      workflow_103:
        "状態変更を通知するユーザーを選ぶ。次の状態が審査の状態であれば、審査者を選んでください",

      e_202: "権限が足りないので、このデータをチェックできない",

      e_203:
        "保存が失敗した！審査者と観察者には同じユーザーを含んではいけない。",
      e_204: "保存が失敗した！データが修正されなかった",

      m_301: "番号はシステムで自動的に生成される",
      m_302:
        "当該操作がこのタイプを削除する（使用中であれば、削除できない）, 継続するか?",
      inLinkage: "連動中です",
      hasSameItem: '次の説明と同じ品目が既に存在します, 継続するか?',

      changeSubClass: 'タイプ（型）を変更すると、一部のデータが完全にコピーされない可能性があります',
      requiredError: ' 必須項目は空欄にできません。以下の必須項目が空欄になっています',
      duplicateObject: 'すでに以下の説明と同じもの（または同じ内容の）が存在する材料（アイテム）がありますが、引き続き作成してもよろしいですか?',

      selcetParentProject: 'Please select a parent project',
      saveCurrentRow: 'まず現在の行を保存してください',
      del_01: '親プランページに移動して、このタスクを削除してください',
      add_01: 'このステージ/マイルストーンではサブタスクを追加できません',
      add_02: 'このタスク下では、ステージ/マイルストーンだけを設定することはできません',

      date_01: '計画開始日は計画終了日以降に設定できません',
      date_02: '現在の状態下では、計画開始日はタスクの計画開始日以降に設定できません',
      date_03: '現在の状態下では、計画開始日は親タスクの開始日以前に設定できません',
      date_04: '計画終了日は計画開始日以前に設定できません',
      date_05: '現在の状態下では、計画終了日はサブタスクの終了日以前に設定できません',
      date_06: '現在の状態下では、計画終了日は親計画の終了日以降に設定できません',

    },
    confirm: {
      modifyCodeAttributes:
        "シリアル番号/バージョン番号をアップグレードする操作で、コードのフィールドの修正を確認するか?",
      deleteSearch: "当該プライベート検索の削除を確認するか?",
      deleteData: "当該データの削除を確認するか?",
      taskDeleteData:
        "タスクた進行中の状態になっている、削除するか、削除するなら、親タスクの状態が変化しない",
      deleteFormList: "当該シートの削除を確認するか?",
      cancelData: "您確認要关闭当該プロジェクトの閉鎖を確認するか?",
      unDoData: "当該データを元に戻すことを確認するか?",
      deleteList: "当該リストを削除するか?",
      deleteObject: "この操作は当該オブジェクトを削除するので、 継続するか?",
      clearSchedule: "この操作は当該プロジェクトをクリアするので、 継続するか?",
      closeAllTabs: "今現在の画面以外の全てのページを閉じるか?",
      logout: "この操作はシステムを終了するので、 継続するか?",
      close: "閉じることを確認するか？",
      overwrite: "当該ファイルが既に存在しているので、上書きするか？",
      closeWithoutSave:
        "現在のページに保存されていない情報があります。本当に離れますか？",
    },
    Auth: {
      authShift: "授権の移転",
      isAuth: "有効化にするか",
      authUser: "ユーザーを授権する",
      scope: "授権のレンジ",
    },
    table: {
      mouserSN: "Mouserフィールド",
      mourserValue: "Mouserフィールドの値 ",
      plmSN: "PLMフィールド",
      manufacturer: "メーカー",
      address: "アドレス",
      name: "名称",
      userName: "ユーザー名",
      userID: "ユーザーID",
      user: "ユーザー",
      fileResources: "ファイルリソース",
      sysUser: "システムユーザー",
      group: "グループ",
      roleName: "キャラクターの名称",
      projectName: "名称",
      baseInfo: "基本情報",
      mark: "ユーザーインターフェースのラベル",
      lifecyclephases: "ライフサイクルの段階",
      newSub: "子分類を新規作成する",
      des: "ディスクリプション",
      status: "状態",
      type: "タイプ",
      displayType: "タイプを表示する",
      listType: "リストタイプ値",
      codeValueLength: "番号の長さ",
      statusValue: "状態値",
      actions: "操作",
      privilege: "権限の名称",
      privilegeType: "権限のタイプ",
      criteria: "標準",
      classify: "分類",
      dataType: "データの分類",
      workflow: "ワークフロー",
      startStatus: "開始の状態",
      endStatus: "終了の状態",
      applied: "に応用された",
      createDate: "新規作成の時間",
      country: "国",
      city: "都市",
      isEnabled: "有効化にするか",
      statusVal_01: "無効",
      statusVal_02: "有効",

      number_: "番号",
      changeDes: "変更のディスクリプション",
      changeStatus: "状態を変更する",
      // workflow:''

      numberLength: "数字の長さ",
      startNumber: "開始の数字",
      prefix: "プリフィックス",
      suffix: "サフィックス",
      nextAutoNumber: "次の番号",

      enabled: "有効化",
      disabled: "無効化",

      enabled_01: "有効化",
      disabled_01: "無効化",

      simple: "普通",
      cascade: "カスケード",
      dynamic: "ダイナミック",
      code: "番号",
      serialNumber: "シリアル番号",
      versionNumber: "バージョン番号",
      reference: "引用",
      SN: "シリアル番号",

      listOrder: "リストをスライドで配列する",
      list: "リスト",
      search: "検索",
      required: "記入しなければならない",
      visible: "可視",

      nextStatus: "次の状態",
      entryReq: "所要のフィルドに入る",
      exitReq: "所要のフィルドから出る",
      ifReject: "拒否すれば、状態を設置してください",
      approver: "審査者",
      observer: "観察者",

      yes: "はい",
      no: "いいえ",
      none: "いいえ",

      selectStartOrEnd: '開始時間 / 終了時間を選択してください',
      templateName: 'テンプレート名',
      copyRelate: "関連者をコピーしますか",
      currency: 'RMB',

      relatedOldDoc: '旧図番号と関連付け',


      order: "配列する",
      property: "プロパティー",
      class: "クラス",
      tab: "タブ",

      PW: "暗証番号",
      oldPW: "古い暗証番号",
      PWagain: "暗証番号を重複する",
      newPW: "新しい暗証番号",
      newPWagain: "暗証番号を重複する",
      PWnotSame: "入力した暗証番号が一致しない",

      pageThree: "第三ページ目",
      title: "タイトル:",

      text: "テキスト",
      textarea: "テキストエリア",
      selectList: "選択リスト",
      multilist: "複数選択リスト",
      date: "デート",
      number: "数字",
      richText: "リッチテキスト",
      money: "貨幣",
      defaultValue: "デフォルト値",
      placeholder: "プレースホルダ",

      weightOfKey: "重点プロジェクトのウェート",
      weightOfNonKey: "非重点プロジェクトのウェート",
      autoVersion: "バージョンを自動的に生成する",
      isVerify: "実際の稼働時間の校正",
      exportChange: "エクスポートリリースの変更",
      cancelAll: "全てをキャンセルする",
      more: "もっと",
      all: "全て",

      onlineNumbers: "オンラインの人数",
      allPerpon: "全ての人",
      linkage: "れんどう",

      rejected: "リリースを拒否する",
      submitDate: "提出の時間",
      createdDate: "新規作成の時間",
      completedDate: "完成の時間",
    },
    warning: {
      alreadyInPersonalSearch: "名称が既に存在している",
      alreadyInFavorite: "コレクション済み",
      searchErr_01: "検索の条件を空きにしてはいけない",
      searchErr_02: "検索の結果が空きであるので、新たに検索してください",
      blankRequired: "記入しなければならない項目を空きにしてはいけない",
      substituteTissueRelNotOneBlank:
        "置き替えの関係と置き替えグループの値を確認してください。",

      length_101: "長さが 3 ～ 25 文字になっている",
      length_102: "長さが 5 ～ 20 文字になっている",
      length_103: "長さが 1 ～ 200 文字になっている",
      length_104: "長さが 5 ～ 15 文字になっている",
      length_105: "長さが 1 ～ 18 文字になっている",
      length_106: "長さが 3 ～ 18 文字になっている",
      length_107: "長さが3～40文字になっている",
      length_108: "長さが5 ～ 40 文字になっている",

      nameRequired: "名称を記入しなければならない",
      inputPW: "暗証番号を入力してください",
      required: "記入しなければならない項目を空きにしてはいけない",

      privilege: "権限の名称を入力してください",
      choice: "アタッチメントを一つ独自で選んでください",
      name: "名称を空きにしてはいけない",
      PW: "暗証番号を空きにしてはいけない",
      PWLength: "長さが 6～ 30文字になっている",
      confirmPW: "暗証番号を空きにしてはいけない",
    },
    workflowType: {
      Pending: "確定待ち",
      Submit: "提出",
      Review: "审批",
      Released: "リリースした",
      Complete: "終了",
      Cancel: "キャンセル",
      Hold: "一時停止",
    },
    ppmWorkflowType: {
      Pending: "処理待ち",
      Progress: "進行中",
      Complete: "完成済み",
      Reject: "もう断った",
      w_101: "先ずはワークフローを選んでください",
    },

    transform: {
      choices: "選択待ちの項目",
      selected: "既に選択された",
      assignRoles: "キャラクターの配布",

      w_101: "先ずはワークフローを選んでください",
    },

    list: {
      baseInfo: "基本情報",
      pageOne: "第一ページ目",
      pageTwo: "第二ページ目",
      pageThree: "第三ページ目",
      pendingChange: "変更を待つ",
      pendingChangeWhereUsed: "使用する位置の変更を待っている",
      changeHistory: "履歴を変更する",
      BOM: "BOM",
      manufacturer: "製造元",
      attachment: "アタッチメント",
      itemAttachment: "物件の添付ファイル",
      whereUsed: "使用する位置",
      relationship: "オブジェクトを関連する",
      historyRecord: "履歴",
      affectedObjects: "オブジェクトを変更する",
      preferences: "プレファレンス",
      userGroup: "ユーザーグループ",
      user: "ユーザー",
      schedule: "計画",
      deliverables: "デリバリー",
      team: "執行者",
      scheduleComments: "計画備考",
      scheduleCommentsTemplate: "計画備考テンプレート",
      questionObject: "問題オブジェクト",
      associateTheSameForm: "同じシートを関連する",

      showAttribute: "フィールド表示c",
      showAttributeName: "フィールド名表示c",
      itemQuality: "品質書類",

      Separator: "区切り記号c",

      duplicateType: 'そのタイプは既に存在します',

    },
    operatorGroup: {
      IsNull: "空きであった",
      IsNotNull: "空きでない",
      EqualTo: "イコール",
      NotEqualTo: "等しくない",
      Like: "類似する",
      NotLike: "類似しない",
      Contains: "を含む",
      DoesNotContains: "含まれない",
      StartsWith: "から開始する",
      DoesNotStartsWith: "に開始しない",
      Between: "にいる",
      NotBetween: "にいない",
      Between_DM: "にいる",
      NotBetween_DM: "にいない",
      ContainsAny: "何れも含まれる",
      ContainsAll: "全数を含む",
      ContainsNone: "何れの をも含まない",
      GreatThan: "上回る",
      GreatThanOrEqualTo: "に下回らない",
      LessThan: "下回る",
      LessThanOrEqualTo: "上回らない",

      and: "論理積",
      or: "論理和",
    },
    performance: {
      firstTitle: "個人パフォーマンス考課のメインシート",
      secondTitle: "プロジェクトのパフォーマンス执行情况(子シート)",
      scoreData: "プロジェクトのパフォーマンスに対して採点する",
      otherScoreData: "非プロジェクトのパフォーマンスの採点",
      HrScoreData: "部署とHRによる考課と採点",
      formNumber: "シートの番号：",
      formName: "シート名：",
      jobNumber: "社員番号：",
      name: "氏名：",
      Department: "所属部署：",
      assessmentDate: "考課日：",
      documentDate: "シートの時間：",
      preparer: "作成者：",
      keyProjects: "重点任務の採点：",
      noKeyProjects: "非重点タスクの採点：",
      assessor: "採点者：",
      otherAssessment: "其の他考課：",
      performanceScoreData: "作業ログの採点：",
      performanceHrScoreData: "5S採点：",
      description: "ディスクリプション：",
      performanceScore: "総合パフォーマンスの考課得点：",
      keyProject: "重点プロジェクトであるか：",
      projectManager: "執行者：",
    },
    agent: {
      principal: "担当責任者",
      projectManager: "プロジェクトのマネジャー",
      observer: "観察者",
      executors: "執行者",
    },
    titleBlockImg: {
      bigImg:
        "写真を最大4MBしかアップロードできないので 、新たにアップロードしてください！",
      notImg:
        "ファイルの書式は写真(jpg,jpeg,gif,png,bmp)なので、新たにアップロードしてください！",
    },
    calendar: {
      currentYear: "今現在の年間",
      day: "日",
      year: "年",
      month: "月",
      week: "週",
      season: "Q",
    },
  },

  ...jpLocale,
  ...jaJP
};

export default jp;
